module.exports = __webpack_public_path__ + "img/jo.337b39b8.svg";